export default __webpack_public_path__ + "OpenSans-Bold.ttf";